import { useEffect } from "react";

// Updates the document title and meta description for the current page.
// CRA has no server-side rendering, so this is how each route gets its own
// title/description for users and for search engines that execute JS.
export default function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
  }, [title, description]);
}
